function postImageURL (folderId: string, fileName: string) {
  return `/api/v1/images/${folderId}/${fileName}`
}

export default postImageURL
